import React from 'react';
export default function CircleBeard({ light, dark }) {
  return (
<><path d="M21.454 19.032c1.954-.039 5.087-3.47 4.248-1.858-1.441 2.771-5.054 5.216-8.517 5.216-3.445 0-6.983-2.116-8.512-5.062-.844-1.626 2.656 1.69 4.557 1.691 1.685.001 1.433-1.642 3.923-1.659 2.851-.019 2.638 1.705 4.301 1.672z" fill={light}/></>); }
